var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"text -t2 -download",attrs:{"href":_vm.file.url}},[_vm._v(_vm._s(_vm.linkText))])}
var staticRenderFns = []

export { render, staticRenderFns }